module.exports = __webpack_public_path__ + "static/img/login_logo_default@3x.d52f8b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/image/login_logo_default@3x.png
// module id = 310
// module chunks = 30